<template>
  <div>
    <Breadcrumb msg1="会员管理" msg2="储值充值" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6">
          <el-select v-model="query.member_id" filterable remote placeholder="按会员手机号搜索" :remote-method="searchMember" clearable style="width: 100%">
            <el-option v-for="m in memberOptions" :key="m.member.id" :label="(m.customer ? m.customer.name : '') + ' ' + (m.customer ? m.customer.phone : '')" :value="m.member.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">储值充值</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="会员ID" prop="memberId" width="100"></el-table-column>
        <el-table-column label="充值金额" prop="amount" width="110"></el-table-column>
        <el-table-column label="赠送金额" prop="giftAmount" width="110"></el-table-column>
        <el-table-column label="支付方式" prop="payMethod" width="100"></el-table-column>
        <el-table-column label="时间" prop="rechargeTime" width="160"></el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog title="储值充值" :visible.sync="show" width="480px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px">
        <el-form-item label="会员" required>
          <el-select v-model="form.member_id" filterable remote placeholder="输入手机号搜索" :remote-method="searchMember" style="width: 100%">
            <el-option v-for="m in memberOptions" :key="m.member.id" :label="(m.customer ? m.customer.name : '') + ' ' + (m.customer ? m.customer.phone : '')" :value="m.member.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="充值金额" required><el-input v-model.number="form.amount" type="number"></el-input></el-form-item>
        <el-form-item label="赠送金额"><el-input v-model.number="form.gift_amount" type="number"></el-input></el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="form.pay_method" style="width: 100%">
            <el-option label="现金" value="现金"></el-option>
            <el-option label="微信" value="微信"></el-option>
            <el-option label="支付宝" value="支付宝"></el-option>
            <el-option label="银行卡" value="银行卡"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">确认充值</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, member_id: null },
      list: [],
      total: 0,
      show: false,
      form: { member_id: null, amount: 0, gift_amount: 0, pay_method: '现金' },
      memberOptions: []
    }
  },
  created () { this.getData() },
  methods: {
    getData () {
      this.$axios.get('/memberRecharges', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchMember (kw) {
      if (!kw) return
      this.$axios.http.get('/members', { params: { page: 1, limit: 20, keyword: kw } }).then(r => {
        if (r.data.status === 200) this.memberOptions = r.data.data.records || []
      })
    },
    add () {
      this.form = { member_id: null, amount: 0, gift_amount: 0, pay_method: '现金' }
      this.show = true
    },
    save () {
      if (!this.form.member_id) { this.$message.warning('请选择会员'); return }
      this.$axios.post('/memberRecharges', () => { this.show = false; this.getData() }, this.form)
    }
  }
}
</script>
